import { useRef } from "react";
import { gsap } from "gsap/all";
import { useEffect } from "react";

function ProductCarousel(props) {
  const carouselRef = useRef();
  const nextBtn = useRef();
  const prevBtn = useRef();
  const totalPages = Math.ceil(props.items.length / props.items_per_page);
  var currPage = 1;

  function adjustHeight() {
    Array.from(carouselRef.current.children).forEach((item, i) => {
      item.classList.remove("active");
      gsap.fromTo(item, { opacity: 1 }, { opacity: 0, duration: 0 });
      if (
        i >= (currPage - 1) * props.items_per_page &&
        i < currPage * props.items_per_page
      ) {
        gsap.fromTo(item, { opacity: 0 }, { opacity: 1, duration: 1 });
        item.classList.add("active");
      }
    });
  }

  function handleNav() {
    console.log("currPage:", currPage);
    if (currPage == 1) {
      gsap.to(prevBtn.current, { opacity: 0.2 });
      gsap.to(nextBtn.current, { opacity: 1 });
      return;
    }
    if (currPage == 2) {
      gsap.to(prevBtn.current, { opacity: 1 });
    }
    if (currPage == totalPages) {
      gsap.to(nextBtn.current, { opacity: 0.2 });
      return;
    }
    if (currPage == totalPages - 1) {
      gsap.to(nextBtn.current, { opacity: 1 });
    }
  }

  function caouselPrev() {
    if (currPage == 1) return;
    const w =
      document.querySelector(props.item_class).offsetWidth *
      props.items_per_page;
    gsap.to(carouselRef.current, {
      x: `+=${w}px`,
    });
    currPage--;
    if (props.dynamic_height) adjustHeight();
    handleNav();
  }
  function caouselNext() {
    if (currPage == totalPages) return;
    const w =
      document.querySelector(props.item_class).offsetWidth *
      props.items_per_page;
    gsap.to(carouselRef.current, {
      x: `-=${w}px`,
    });
    currPage++;
    if (props.dynamic_height) adjustHeight();
    handleNav();
  }

  useEffect(() => {
    if (props.dynamic_height) {
      Array.from(carouselRef.current.children).forEach((item, i) => {
        if (i < props.items_per_page) {
          item.classList.add("active");
        }
      });
    }
  }, []);

  return (
    <div
      className={
        (props.dynamic_height ? "dynamic_height " : "") +
        "products_carousel my-10"
      }
    >
      <div className="items_wrapper" ref={carouselRef}>
        {props.items}
      </div>
      {totalPages > 1 ? (
        <nav>
          <div className="nav left" ref={prevBtn} onClick={caouselPrev}>
            <svg
              width="54"
              height="54"
              viewBox="0 0 54 54"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M27 4.5C39.4294 4.5 49.5 14.5706 49.5 27C49.5 39.4294 39.4294 49.5 27 49.5C14.5706 49.5 4.5 39.4294 4.5 27C4.5 14.5706 14.5706 4.5 27 4.5ZM24.378 17.5282L31.2278 24.0968H14.6613C13.4546 24.0968 12.4839 25.0675 12.4839 26.2742V27.7258C12.4839 28.9325 13.4546 29.9032 14.6613 29.9032H31.2278L24.378 36.4718C23.498 37.3155 23.4798 38.7218 24.3417 39.5837L25.3397 40.5726C26.1925 41.4254 27.5716 41.4254 28.4153 40.5726L40.4546 28.5423C41.3075 27.6895 41.3075 26.3105 40.4546 25.4667L28.4153 13.4183C27.5625 12.5655 26.1835 12.5655 25.3397 13.4183L24.3417 14.4073C23.4798 15.2782 23.498 16.6845 24.378 17.5282Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="nav right" ref={nextBtn} onClick={caouselNext}>
            <svg
              width="54"
              height="54"
              viewBox="0 0 54 54"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M27 4.5C39.4294 4.5 49.5 14.5706 49.5 27C49.5 39.4294 39.4294 49.5 27 49.5C14.5706 49.5 4.5 39.4294 4.5 27C4.5 14.5706 14.5706 4.5 27 4.5ZM24.378 17.5282L31.2278 24.0968H14.6613C13.4546 24.0968 12.4839 25.0675 12.4839 26.2742V27.7258C12.4839 28.9325 13.4546 29.9032 14.6613 29.9032H31.2278L24.378 36.4718C23.498 37.3155 23.4798 38.7218 24.3417 39.5837L25.3397 40.5726C26.1925 41.4254 27.5716 41.4254 28.4153 40.5726L40.4546 28.5423C41.3075 27.6895 41.3075 26.3105 40.4546 25.4667L28.4153 13.4183C27.5625 12.5655 26.1835 12.5655 25.3397 13.4183L24.3417 14.4073C23.4798 15.2782 23.498 16.6845 24.378 17.5282Z"
                fill="white"
              />
            </svg>
          </div>
        </nav>
      ) : null}
    </div>
  );
}

export default ProductCarousel;
